import React, { useState, useEffect } from 'react';
import { resetPassword } from '../../services/AuthService';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { AppButton } from '../../components/AppButton/AppButton';
import AuthLayout from '../../components/Auth/AuthLayout';
import AuthField from '../../components/Auth/AuthField';

const passwordIcon = (
  <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
  </svg>
);

function ResetPassword() {
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState({ loading: false, message: '', error: false });

  useEffect(() => {
    if (!token) {
      setStatus({ loading: false, message: 'Invalid or missing reset token.', error: true });
    }
  }, [token]);

  async function onSubmit(event) {
    event.preventDefault();
    if (!token) return;

    if (password.length < 6) {
      setStatus({ loading: false, message: 'Password must be at least 6 characters.', error: true });
      return;
    }

    if (password !== confirm) {
      setStatus({ loading: false, message: 'Passwords do not match.', error: true });
      return;
    }

    setStatus({ loading: true, message: '', error: false });

    try {
      const res = await resetPassword(token, password);
      setStatus({
        loading: false,
        message: res?.message || 'Password reset successful. You can now sign in.',
        error: false,
      });
      setTimeout(() => history.push('/login'), 1500);
    } catch (err) {
      console.error(err);
      const msg = err?.response?.data?.message || 'An error occurred while resetting the password.';
      setStatus({ loading: false, message: msg, error: true });
    }
  }

  return (
    <AuthLayout
      title="Set a new password"
      description="Choose a new password for your account."
      footer={(
        <>
          Back to{' '}
          <Link to="/login" className="auth-link">sign in</Link>
        </>
      )}
    >
      <form onSubmit={onSubmit}>
        <AuthField
          id="password"
          label="New password"
          type="password"
          placeholder="Enter a new password"
          icon={passwordIcon}
          autoFocus
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <AuthField
          id="confirm"
          label="Confirm password"
          type="password"
          placeholder="Confirm your new password"
          icon={passwordIcon}
          value={confirm}
          onChange={(event) => setConfirm(event.target.value)}
        />

        <AppButton
          type="submit"
          variant="primary"
          size="lg"
          fullWidth
          disabled={status.loading || !token}
        >
          {status.loading ? 'Saving…' : 'Save new password'}
        </AppButton>

        {status.message ? (
          <div className={`auth-alert ${status.error ? 'auth-alert-error' : 'auth-alert-success'}`}>
            {status.message}
            {!status.error ? (
              <div className="mt-2">
                <Link to="/login" className="auth-link">Go to sign in</Link>
              </div>
            ) : null}
          </div>
        ) : null}
      </form>
    </AuthLayout>
  );
}

export default ResetPassword;